/* Users management i18n — kept separate from main i18n bundle to avoid bloating it. */
export const USERS_T = {
  ar: {
    title: "إدارة المستخدمين والصلاحيات",
    back: "رجوع",
    create: "إضافة مستخدم",
    search_placeholder: "بحث بالاسم، اسم المستخدم، الجوال...",
    f_all: "الكل",
    f_internal: "موظفون",
    f_client: "عملاء",
    tab_admin: "الإدارة",
    tab_employees: "الموظفون",
    tab_clients: "العملاء",
    tab_admin_hint: "STAS، المدير العام، النائب، المحاسب",
    tab_employees_hint: "موظفو التنفيذ والتوظيف والإدخال",
    tab_clients_hint: "جهات اتصال للتسويق فقط — لا صلاحيات دخول",
    marketing_only_hint: "بيانات العميل تُخزَّن للمتابعة والتسويق فقط. لا يستطيع تسجيل الدخول، ولا كلمة مرور.",
    marketing_badge: "للتسويق",
    whatsapp: "واتساب",
    call: "اتصال",
    view_applications: "معاملاته",
    notes: "ملاحظات",
    count_users: (n) => `${n} مستخدم`,
    empty: "لا توجد نتائج",
    not_root: "هذه الصفحة متاحة لـ STAS فقط.",
    active: "مفعّل",
    inactive: "معطّل",
    internal: "موظف",
    client: "عميل",
    role: "الدور",
    last_login: "آخر دخول",
    never_logged_in: "لم يدخل بعد",
    email: "البريد",
    mobile: "الجوال",
    edit: "تعديل",
    password: "كلمة المرور",
    activate: "تفعيل",
    deactivate: "تعطيل",
    switch_to: "تبديل إليه",
    delete: "حذف",
    username: "اسم المستخدم",
    full_name: "الاسم الكامل",
    new_password: "كلمة المرور الجديدة",
    confirm_password: "تأكيد كلمة المرور",
    user_type: "نوع المستخدم",
    cancel: "إلغاء",
    confirm: "حفظ",
    confirm_delete_btn: "حذف نهائي",
    err_password_mismatch: "كلمتا المرور غير متطابقتين",
    modal_create: "إضافة مستخدم جديد",
    modal_edit: "تعديل بيانات المستخدم",
    modal_password: "تغيير كلمة المرور",
    modal_activate: "تفعيل المستخدم",
    modal_deactivate: "تعطيل المستخدم",
    modal_delete: "حذف المستخدم",
    modal_switch: "تبديل إلى مستخدم",
    password_hint: (name) =>
      `سيتم تحديث كلمة مرور ${name}. لن تُعرض كلمة المرور الحالية. أدخل القيمة الجديدة فقط.`,
    confirm_activate: (name) => `هل تريد تفعيل المستخدم "${name}"؟`,
    confirm_deactivate: (name) => `هل تريد تعطيل المستخدم "${name}"؟ لن يستطيع تسجيل الدخول.`,
    confirm_delete: (name) => `سيتم حذف "${name}" نهائياً. هذا الإجراء غير قابل للتراجع.`,
    confirm_switch: (name) =>
      `سيتم تبديل جلستك إلى "${name}". كل التبديلات تُسجَّل في سجل التتبع. هل تريد المتابعة؟`,
  },
  en: {
    title: "Users & Access",
    back: "Back",
    create: "Add user",
    search_placeholder: "Search by name, username, phone…",
    f_all: "All",
    f_internal: "Internal",
    f_client: "Clients",
    tab_admin: "Administration",
    tab_employees: "Employees",
    tab_clients: "Clients",
    tab_admin_hint: "STAS, GM, Deputy, Accountant",
    tab_employees_hint: "Operations, recruitment, data entry",
    tab_clients_hint: "Marketing contacts only — no login access",
    marketing_only_hint: "Client data is stored for follow-up and marketing only. No login, no password.",
    marketing_badge: "Marketing",
    whatsapp: "WhatsApp",
    call: "Call",
    view_applications: "Applications",
    notes: "Notes",
    count_users: (n) => `${n} user${n === 1 ? "" : "s"}`,
    empty: "No results",
    not_root: "STAS only.",
    active: "Active",
    inactive: "Disabled",
    internal: "Internal",
    client: "Client",
    role: "Role",
    last_login: "Last login",
    never_logged_in: "Never",
    email: "Email",
    mobile: "Phone",
    edit: "Edit",
    password: "Password",
    activate: "Activate",
    deactivate: "Deactivate",
    switch_to: "Switch to",
    delete: "Delete",
    username: "Username",
    full_name: "Full name",
    new_password: "New password",
    confirm_password: "Confirm password",
    user_type: "User type",
    cancel: "Cancel",
    confirm: "Save",
    confirm_delete_btn: "Delete permanently",
    err_password_mismatch: "Passwords do not match",
    modal_create: "Create new user",
    modal_edit: "Edit user",
    modal_password: "Change password",
    modal_activate: "Activate user",
    modal_deactivate: "Deactivate user",
    modal_delete: "Delete user",
    modal_switch: "Switch to user",
    password_hint: (name) =>
      `${name}'s password will be updated. The current password is never shown. Enter the new value only.`,
    confirm_activate: (name) => `Activate "${name}"?`,
    confirm_deactivate: (name) => `Deactivate "${name}"? They will not be able to sign in.`,
    confirm_delete: (name) => `"${name}" will be permanently deleted. This cannot be undone.`,
    confirm_switch: (name) =>
      `Your session will switch to "${name}". Every switch is recorded in audit logs. Continue?`,
  },
};
